/**
 * Storage permissions.
 *
 * @id - Used to identify the rule on permissions and upload.
 * @folder - Folder where the files will be saved
 * @maxSizeInBytes - Max allowed size in bytes
 * @bypassWritingPermissions - Does not validate if the user has permission to write
 * @publicRead - The file can be publicly accessed via the URL without the need for a signed token
 */
export default class Storage {
  static get values() {
    return {
      eventMainImage: {
        id: 'eventMainImage',
        folder: 'tenant/:tenantId/event/mainImage',
        maxSizeInBytes: 100 * 1024 * 1024,
      },
      eventOrganizerLogo: {
        id: 'eventOrganizerLogo',
        folder: 'tenant/:tenantId/event/organizerLogo',
        maxSizeInBytes: 100 * 1024 * 1024,
      },
      eventResources: {
        id: 'eventResources',
        folder: 'tenant/:tenantId/event/resources',
        maxSizeInBytes: 100 * 1024 * 1024,
      },
      eventSponsorLogo: {
        id: 'eventSponsorLogo',
        folder: 'tenant/:tenantId/event/sponsorLogo',
        maxSizeInBytes: 100 * 1024 * 1024,
      },
      eventCallToActionLogo: {
        id: 'eventCallToActionLogo',
        folder: 'tenant/:tenantId/event/callToActionLogo',
        maxSizeInBytes: 100 * 1024 * 1024,
      },
      eventDailyCoverageSponsorLogo: {
        id: 'eventDailyCoverageSponsorLogo',
        folder: 'tenant/:tenantId/event/dailyCoverageSponsorLogo',
        maxSizeInBytes: 100 * 1024 * 1024,
      },


















      settingsLogos: {
        id: 'settingsLogos',
        folder: 'tenant/:tenantId/settings/logos',
        maxSizeInBytes: 10 * 1024 * 1024,
        publicRead: true,
      },
      settingsBannerLogos: {
        id: 'settingsBannerLogos',
        folder: 'tenant/:tenantId/settings/bannerLogos',
        maxSizeInBytes: 10 * 1024 * 1024,
        publicRead: true,
      },
      settingsBackgroundImages: {
        id: 'settingsBackgroundImages',
        folder:
          'tenant/:tenantId/settings/backgroundImages',
        maxSizeInBytes: 10 * 1024 * 1024,
        publicRead: true,
      },
      userAvatarsProfiles: {
        id: 'userAvatarsProfiles',
        folder: 'user/avatars/profile/:userId',
        maxSizeInBytes: 10 * 1024 * 1024,
        bypassWritingPermissions: true,
        publicRead: true,
      },
    };
  }
}
